module.exports = __webpack_public_path__ + "static/media/pre-photo-product.e3b46773.jpg";